import styled from "styled-components";

export const StructureImageWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 13px;
  background: #fff;
  z-index: 1000;
  display: flex;
  padding: 40px 30px;
  display: flex;
  flex-direction: column;
`;

export const StructureImageHeader = styled.div`
  color: #1a191a;
  font-family: Pretendard;
  font-size: 23px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const StructureImageBody = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 30px;
  gap: 20px;
  width: 100%;
`;

export const StructureImageLeftBody = styled.div`
  width: 470px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const StructureImageInformationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 16px 30px;
  border-radius: 8px;
  height: 100%;
  background: #f0f0f0;
  gap: 20px;
`;

export const StructureImageInformationBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 70px;
`;

export const StructureImageInformationRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const StructureImageInformationItem = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;

  > .title {
    width: 108px;
    color: #000;
    font-family: Pretendard;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  > .value {
    color: #000;
    font-family: Pretendard;
    font-size: 13px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`;

export const StructureImageEarlyBirdBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;

  > .title {
    width: 108px;
    color: #000;
    font-family: Pretendard;
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`;

export const StructureImageEarlyBirdGridBox = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 1fr);
  row-gap: 10px;
`;

export const StructureImageEarlyBirdItem = styled.div`
  width: 106px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #000;
  text-align: center;
  font-family: Pretendard;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const StructureImagePrizeWrapper = styled.div`
  flex: 1;
  padding: 20px 16px 30px;
  min-height: 353px;
  border-radius: 8px;
  background: #f0f0f0;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const StructureImagePrizeRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 46px;
  justify-content: center;
`;

export const StructureImagePrizeBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const StructureImagePrizeHeader = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

export const StructureImagePrizeHeaderItem = styled.div`
  display: flex;
  height: 22px;
  width: 60px;
  border-radius: 8px;
  background: #6436e7;
  justify-content: center;
  align-items: center;
  color: #fff;
  text-align: center;
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const StructureImagePrizeListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const StructureImagePrizeListRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;

  > .value {
    height: 22px;
    width: 60px;
    color: #121212;
    text-align: center;
    font-family: Pretendard;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const StructureLeftBodyTitle = styled.div`
  color: #000;
  font-family: Pretendard;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const StructureImageRightBody = styled.div`
  width: 365px;
  min-height: 649px;
  padding: 20px 16px 30px;
  border-radius: 8px;
  background: #f0f0f0;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const StructureImageRightBodyHeader = styled.div`
  display: flex;
  flex-direction: row;
  gap: 25px;
`;

export const StructureImageRightBodyHeaderItem = styled.div`
  display: flex;
  height: 22px;
  width: 53px;
  border-radius: 8px;
  background: #6436e7;
  justify-content: center;
  align-items: center;
  color: #fff;
  text-align: center;
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const StructureImageRightBodyListWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StructureImageRightBodyListRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 25px;

  > .break {
    height: 22px;
    width: 53px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #121212;
    text-align: center;
    font-family: Pretendard;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  > .value {
    height: 22px;
    width: 53px;
    color: #121212;
    text-align: center;
    font-family: Pretendard;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const StructureButtonWrapper = styled.div`
  position: absolute;
  z-index: 1001;
  top: 3%;
  right: 1%;
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

export const StructureCloseButton = styled.div`
  border-radius: 8px;
  background: rgb(187, 187, 187);
  padding: 10px 16px;
  color: #fff;
  cursor: pointer;
`;

export const StructureToImageButton = styled.div`
  border-radius: 8px;
  background: rgb(79, 186, 194);
  padding: 10px 16px;
  color: #fff;
  cursor: pointer;
`;
